import moment from "moment";

const formatFrontendDate = (dateString) => {
    if (!dateString) return "Invalid Date"; // Handle null/undefined input
    const date = moment(dateString);
    if (!date.isValid()) {
        return "Invalid Date";
    }
    return date.format("DD-MM-YYYY"); // Ensure it returns a string
}

export default formatFrontendDate;